/**
 * Select a Job Priority.
 */
// @todo: Migrate to 'Select' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Select} from '@wandb/weave/components/Form/Select';
import {IconName} from '@wandb/weave/components/Icon';
import React, {useMemo} from 'react';
import {FormatOptionLabelMeta} from 'react-select';

import {PRIORITY_LEVEL, PRIORITY_LEVEL_METADATA} from './constants';
import * as S from './SelectComponents.styles';

export type PriorityOption = {
  value: PRIORITY_LEVEL;
  label: string;
  icon: IconName;
};

type SelectPriorityProps = {
  value?: PRIORITY_LEVEL;
  disabled?: boolean;
  onSelectPriority: (level: PRIORITY_LEVEL) => void;
};

const OptionLabel = (
  props: PriorityOption,
  meta: FormatOptionLabelMeta<PriorityOption>
) => {
  const {label, icon} = props;

  return (
    <S.SelectOption>
      <S.SelectOptionIcon name={icon} />
      <S.SelectOptionLabel>{label}</S.SelectOptionLabel>
    </S.SelectOption>
  );
};

const options: PriorityOption[] = [
  PRIORITY_LEVEL.CRITICAL,
  PRIORITY_LEVEL.HIGH,
  PRIORITY_LEVEL.MEDIUM,
  PRIORITY_LEVEL.LOW,
].map(level => ({
  value: level,
  label: PRIORITY_LEVEL_METADATA[level].label,
  icon: PRIORITY_LEVEL_METADATA[level].icon,
}));

export const SelectPriority = ({
  value,
  disabled,
  onSelectPriority,
}: SelectPriorityProps) => {
  const onChange = (option: PriorityOption | null) => {
    if (option) {
      onSelectPriority(option.value);
    }
  };

  const optionValue = useMemo(
    () => options.find(option => option.value === value),
    [value]
  );

  return (
    <Select<PriorityOption, false>
      isDisabled={disabled}
      options={options}
      value={optionValue}
      onChange={onChange}
      formatOptionLabel={OptionLabel}
      placeholder="Select a priority level"
    />
  );
};
